var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Facebook"}},[_c('b-button',{staticClass:"btn btn-block facebookBtn mx-1 px-1",on:{"click":_vm.socialFacecbookLogin}},[_c('i',{staticClass:"mx-1 fa fa-facebook"}),_vm._v(" Facebook")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }